import React, { Fragment } from 'react'
import { ButtonLink, Loader } from 'stylist'
import { Route, Switch } from 'react-router-dom'
import RouteShow from './show'
import RouteEdit from './edit'
import Server from 'components/Server'
import ServerProvider from 'components/Server/Provider'
import Header from 'components/Header'

const RouteServer = ({ match: { url, params, path }, location }) => (
  <ServerProvider variables={params}>
    <Server
      render={({ loading, server }) =>
        loading ? (
          <Loader size="lg" centered />
        ) : (
          <Fragment>
            <ButtonLink marginBottom to="/admin/servers" size="sm">
              Back
            </ButtonLink>
            <Header>
              <div>
                <h3>{server && server.hostname}</h3>
              </div>
              <div>
                {!/\/edit\/?$/.test(location.pathname) && (
                  <ButtonLink to={`${url}/edit`}>Edit</ButtonLink>
                )}
              </div>
            </Header>
            <div>
              <Switch>
                <Route path={`${path}/edit`} component={RouteEdit} />
                <Route path={url} component={RouteShow} />
              </Switch>
            </div>
          </Fragment>
        )
      }
    />
  </ServerProvider>
)

export default RouteServer



// WEBPACK FOOTER //
// ./src/routes/admin/servers/server.js